// extracted by mini-css-extract-plugin
export default {"navigation__content":"NavigationAdmin_navigation__content__GWxPi","link":"NavigationAdmin_link__WfbXY","active":"NavigationAdmin_active__oFaa6"};